import { useEffect } from 'react'
import { SocketMessage } from '../types/messaging'
import { useDevices } from './useDevices'

export interface MessageFilterProps {
  filter: (s: SocketMessage) => boolean
  onMatch: (s: SocketMessage, state: any) => any
  onTimeout?: () => void
  timeout?: number
  isReady?: (state: any) => boolean
  initialState?: any
  depends?: any
}

/**
 * This hook starts listening all incoming messages and calls `onMatch` when
 * the first matching message is received. Optionally timeout function and
 * expiry time can be defined. Optionally internal state can be initialized and used
 * in functions.
 */
export function useMessageFilter(props: MessageFilterProps) {
  const { timeout = 0, onTimeout = () => null, filter, onMatch, depends } = props
  const { control } = useDevices()

  useEffect(() => {
    let expired: boolean = false
    let found: boolean = false
    let timer: any
    let state: any = props.initialState

    const isReady = props.isReady || ((state) => found)

    if (timeout) {
      timer = setTimeout(() => {
        if (!isReady(state) && !expired) {
          expired = true
          onTimeout()
        }
      }, timeout)
    }

    const hook = (msg: SocketMessage) => {
      if (!isReady(state) && !expired && filter(msg)) {
        found = true
        state = onMatch(msg, state)
      }
    }

    control.registerHook(hook)
    return () => {
      if (timer) clearTimeout(timer)
      control.unregisterHook(hook)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, depends || [])
}
